// src/pages/tenant/PaymentProcessing.jsx
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';
import logo from '../../assets/elevatelogonew.png';
import { getAuth } from 'firebase/auth';
import {
  doc,
  updateDoc,
  getDoc,
  collection,
  addDoc,
  serverTimestamp
} from 'firebase/firestore';
import { db } from '../../firebase';

export default function PaymentProcessing() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const auth = getAuth();
    const user = auth.currentUser;
if (!user || !location.state) {
  console.error("Missing user or payment state:", { user, state: location.state });
  return;
}
    const processPayment = async () => {
      const {
        paymentAmount,
        paymentMethod,
        fee,
        total,
        formattedDate
      } = location.state || {};

      if (!user || !paymentAmount) return;

      const userRef = doc(db, 'users', user.uid);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {
        const currentBalance = userSnap.data().balance || 0;
        const newBalance = currentBalance - paymentAmount;

        // Update balance
        await updateDoc(userRef, {
          balance: parseFloat(newBalance.toFixed(2))
        });

        // Log payment
        const paymentsRef = collection(db, 'users', user.uid, 'payments');
        await addDoc(paymentsRef, {
          amountPaid: paymentAmount,
          paymentMethod,
          processingFee: fee,
          totalPaid: total,
          date: formattedDate,
          createdAt: serverTimestamp()
        });
      }

      // Redirect
      setTimeout(() => {
        navigate('/tenant/thankyou');
      }, 6000);
    };

    processPayment();
  }, [location, navigate]);

  return (
    <Box
      height="80vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
    >
      <img
        src={logo}
        alt="Memphis Passive"
        style={{
          width: 300,
          marginBottom: 20,
          animation: 'pulse 1.5s infinite ease-in-out'
        }}
      />
      <Typography variant="h6" mb={2}>
        Processing your payment...
      </Typography>
      <CircularProgress color="success" size={40} />

      <style>
        {`
          @keyframes pulse {
            0% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.1); opacity: 0.6; }
            100% { transform: scale(1); opacity: 1; }
        `}
      </style>
    </Box>
  );
}